
import { z } from 'zod';

export type PinVerificationStatus = {
  exists: boolean;
  loading: boolean;
};

export interface CardDetails {
  cardNumber: string;
  cardholderName: string;
  expiryDate: string;
  cvv: string;
}

export interface PinEmailTransferProps {
  onSuccess?: () => void;
}

export interface LocationState {
  email?: string | null;
  amount?: number;
  paymentMethod?: string;
}

// Add the missing schema
export const pinEmailSchema = z.object({
  email: z.string().email("Please enter a valid email address"),
  pin: z.string().min(4, "PIN must be at least 4 characters"),
  amount: z.number().min(0.01, "Amount must be greater than 0")
});

export type PinEmailTransferFormProps = {
  onTransferComplete: () => void;
  onBack: () => void;
};
